"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingPrompt = void 0;

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _MeetingModal = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/MeetingModal"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _prompt = (0, _Promptable.default)(_MeetingModal.default);

var MeetingPrompt = function MeetingPrompt(propsToPass) {
  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};

exports.MeetingPrompt = MeetingPrompt;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/communicationMethods/MeetingPrompt.js
// module id = 646
// module chunks = 5 6